import { NgIf } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, signal, WritableSignal } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { Data, NavigationEnd, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, MenuController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { catchError, concatMap, distinctUntilChanged, first, map, of, Subject, Subscription, switchMap, takeUntil, timer } from "rxjs";
import { TabRepositoryService } from "src/app/pages/tabs/tab-repository.service";
import { AnimationService } from "src/app/services/animation.service";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { NotificationManagerService } from "src/app/services/notification-manager.service";
import { VoucherService } from "src/app/services/vouchers.service";
import { NarratorService } from "../../services/narrator.service";
import { NotificationComponent } from "../notification/notification.component";

@Component({
  selector: "app-top-header",
  templateUrl: "./top-header.component.html",
  styleUrls: ["./top-header.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    LottieComponent,
    NotificationComponent,
    NgIf
  ],
})
export class TopHeaderComponent implements OnInit {
  pageHeading;
  pageHeaderClass;
  heading: any;
  narratorData: Data;
  redDotUnread$ = this.tabsRepoService.redDotUnread$;
  options: AnimationOptions = {
    path: "/assets/notification-animation.json",
  };
  voucherStatus: WritableSignal<boolean> = signal(false)
  private voucherSubscription: Subscription;
  private animationDestroy$ = new Subject<void>();
  updateAnimationSubject = new Subject<{ location_id: string, delayTime: number }>();
  userId: string;
  inboxOptions: AnimationOptions = { path: '' };
  menuOptions: AnimationOptions = { path: '' };
  menuStatus: boolean;
  inboxStatus = signal<boolean>(false);
  menuDuration: number;
  inboxDuration: number;
  private translationEnabled = false;
  routingArray = [
    "/mainTabs/tabs/home",
    "/mainTabs/tabs/home-scroll",
    "/mainTabs/tabs/home-feed",
    "/mainTabs/tabs/store",
    "/mainTabs/tabs/game",
    "/mainTabs/tabs/syndicate",
    "/mainTabs/tabs/voucher",
    "/mainTabs/tabs/charity",
    "/mainTabs/tabs/social",
  ];
  constructor(
    private router: Router,
    public translate: TranslateService,
    private matDialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private GTMSegment: GTMSagmentService,
    private menu: MenuController,
    private narratorService: NarratorService,
    private authService: AuthService,
    private tabsRepoService: TabRepositoryService,
    private voucherService: VoucherService,
    private animationService: AnimationService,
    private chengeDetector: ChangeDetectorRef,
    private notificationManagerService: NotificationManagerService,
  ) {
    this.translationEnabled = this.tabsRepoService.translationLoaded.value;
    this.notificationManagerService.narratorTipTrackerForChangeDetection$.subscribe((data) => {
      if (data?.page === "menu") {
        this.chengeDetector.markForCheck();
      }
    })
  }

  async ngOnInit() {
    await this.authService.getUid("TopHeaderComponent").then((uid) => {
      this.userId = uid;
    })
    this.router.events.subscribe((event) => {
      // The title is fetched only when the navigation has completed.
      if (event instanceof NavigationEnd) {
        this.getTitle();
      }
    });
    // This method is used to get the voucher status
    this.getVoucherStatus();
    if (this.userId) {
      this.getAnimation();
    }
    this.initUpdateAnimation();
    this.getTitle();
  }

  getAnimation() {
    this.animationService.getAnimationFB(this.userId)?.pipe(
      map((response: Data) => response?.general),
      takeUntil(this.animationDestroy$)
    )?.subscribe((res: Data) => {
      res?.forEach(item => {
        switch (item?.location_id) {
          case 'inbox_icon':
            this.animationService.listenToInboxStatus(this.userId)
              .pipe(distinctUntilChanged())  // Ensure updates are detected
              .subscribe((statusRes: Data) => {
                this.inboxStatus.set(statusRes?.inbox ?? false);
                this.chengeDetector.detectChanges(); // Ensure UI updates
              });
            this.inboxDuration = item?.duration;
            this.inboxOptions = {
              path: `../../../assets/${item?.lottie_animation_URL}`,
            };
            break;
          case 'menu_icon':
            this.menuStatus = item?.status;
            this.menuDuration = item?.duration;
            this.menuOptions = {
              path: `../../../assets/${item?.lottie_animation_URL}`,
            };
            break;
        }
      });
      this.chengeDetector.detectChanges();
    })
  }

  initUpdateAnimation() {
    this.updateAnimationSubject
      .pipe(
        concatMap(({ location_id, delayTime }) =>
          timer(delayTime * 1000).pipe(
            switchMap(() => this.sendUpdateStatusFB(location_id))
          )
        )
      ).subscribe();
  }

  // Dismiss the animation when user clicks on it.
  updateAnimationStatus(location_id: string, delayTime: number = 0) {
    if (location_id && delayTime > 0 && delayTime != null) {
      this.updateAnimationSubject.next({ location_id, delayTime });
    }
  }

  onClick(location_id: string) {
    this.sendUpdateStatusFB(location_id).subscribe();
  }

  sendUpdateStatusFB(location_id: string) {
    if (!location_id) return of(null);

    if (this.inboxStatus || this.menuStatus) {
      return this.authService.getV2CloudFunction("updatemicroanimationv2", {
        "userId": this.userId,
        "locationIds": location_id,
        "status": false
      });
    } else {
      return of(null);
    }
  }

  openAnimation() {
    // this.router
    //   .navigateByUrl("/lottieplayer")
    //   .then(() => {
    //   })
    //   .catch((err) => {
    //   });
  }
  getTitle() {
    this.translate
      .get([
        "pageHeading.home",
        "pageHeading.Store",
        "pageHeading.Free",
        "pageHeading.Syndicates",
        "pageHeading.Vouchers",
        "pageHeading.Charity",
        "pageHeading.Social",
      ])
      .subscribe((res: string) => {


        let h = [];
        h.push({
          home: res["pageHeading.home"],
          store: res["pageHeading.Store"],
          free: res["pageHeading.Free"],
          syndicate: res["pageHeading.Syndicates"],
          voucher: res["pageHeading.Vouchers"],
          charity: res["pageHeading.Charity"],
          social: res['pageHeading.Social'],
        }, err => { return (err) });
        this.heading = h[0];
        this.updatePageHeadingAndPageHeaderClass();
      });
    //this.updatePageHeadingAndPageHeaderClass();
  }

  private updatePageHeadingAndPageHeaderClass() {
    const urlPath = window.location.pathname;
    const home = "/mainTabs/tabs/home";
    const home_scroll = "/mainTabs/tabs/home-scroll";
    const store = "/mainTabs/tabs/store";
    const home_feed = "/mainTabs/tabs/home-feed";
    const games_feed = "/mainTabs/tabs/game-new";
    const game = "/mainTabs/tabs/game";
    const syndicate = "/mainTabs/tabs/syndicate";
    const voucher = "/mainTabs/tabs/voucher";
    const charity = "/mainTabs/tabs/charity";
    const social = "/mainTabs/tabs/social";

    if (urlPath === home || urlPath === home_scroll) {
      this.pageHeading = this.heading?.home ? this.heading?.home : "Home";
      this.pageHeaderClass = "home-head";
    } else if (urlPath === store) {
      this.pageHeading = this.heading?.store ? this.heading?.store : "Store";
      this.pageHeaderClass = "store-head";
    } else if (urlPath === game || urlPath === games_feed) {
      this.pageHeading = this.heading?.free ? this.heading?.free : "Games";
      this.pageHeaderClass = "game-head";
    } else if (urlPath === home_feed) {
      this.pageHeading = this.heading?.home ? this.heading?.home : "Home";
      this.pageHeaderClass = "game-head";
    } else if (urlPath === syndicate) {
      this.pageHeading = this.heading?.syndicate ? this.heading?.syndicate : "Syndicate";
      this.pageHeaderClass = "syndicate-head";
    } else if (urlPath === voucher) {
      this.pageHeading = this.heading?.voucher ? this.heading?.voucher : "Voucher Wallet";
      this.pageHeaderClass = "voucher-head";
    } else if (urlPath === charity) {
      this.pageHeading = this.heading?.charity ? this.heading?.charity : "Lotto Social Charity";
      this.pageHeaderClass = "charity-head";
    } else if (urlPath === social) {
      this.pageHeading = this.heading?.social ? this.heading?.social : "Social";
      this.pageHeaderClass = "social-head";
    }
  }

  public async openLeftMenu() {
    if (this.userId)
      this.narratorShow();
    try {
      this.bottomSheet.dismiss();
      this.GTMSegment.GTMPopupInitialization("Side Menu");
      const userData = await this.authService.userDetails$?.pipe(first()).toPromise();
      this.authService.setShowTapAnimation(false);
      if (!userData?.['hide_hand_animation_menu'] && userData?.referral_code) {
        this.authService?.showTouchAnimation?.next(true);
      }
      await this.menu.open("sideMenu").catch((err) => {
        return err;
      });
    } catch (e) {
      this.closeLeftMenu();
    }
  }

  public async closeLeftMenu() {
    await this.menu.close().catch((err => err));
  }

  // This methode has been used for display Narrator tip
  public narratorShow() {
    if (this.narratorService) {
      try {
        this.narratorService.getNarratorTipsHome().pipe(
          catchError(() => of([]))
        ).subscribe(
          (res: Data) => {
            const narratorTipArray: Data = res;
            this.narratorData = [];
            // check narratorTipArray if it is not empty then show narrator tips
            if (narratorTipArray) {
              narratorTipArray.find((response: Data) => {
                if (response?.setting?.page_name == 'menu' && response?.setting?.seen == false) {
                  this.narratorData = response;
                  return true; // return true to stop searching
                }
                return false;
              });
            }
            if (this.narratorData?.setting?.seen == false && this.narratorData?.setting?.page_name == 'menu') {
              this.matDialog.closeAll();
              this.narratorData.urlPageName = 'menu';
              this.authService.setShowMenuNarratorTip(true);
              this.notificationManagerService.addNotification({ ...this.narratorData, type: "narrator_tip" });
            }
          },
          (error) => {
            // handle error when API failed to respond
            return;
          }
        );
      } catch (err) {
        // catch error when some functionality fail
        throw new Error('An error occurred: ' + err.message);
      }
    } else {
      throw new Error('NarratorService is not available.');
    }
  }

  /**
   * Fetches the voucher list and updates the voucher status based on the response.
   * Sets the voucher status to `true` if the list has items, otherwise `false`.
   * Handles errors by setting the voucher status to `false` if an error occurs.
   */
  getVoucherStatus() {
    // Subscribe to the voucher list observable from the service
    this.voucherSubscription = this.voucherService.getVoucherList().subscribe(
      (res: Data) => {
        if (res) {
          // Update the voucher status based on the response  
          const newVoucher = res?.filter((el) => !el?.isSeen);
          const status = newVoucher?.length > 0 ? true : false;
          this.voucherStatus.set(status);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.voucherStatus.set(false);
        return error;
      }
    );
  }

  // Closes the notification by setting the voucher status to `false`.
  closeNotification() {
    this.voucherStatus.set(false);
  }
  // Unsubscribes from the voucher list observable when the component is destroyed
  ngOnDestroy() {
    if (this.voucherSubscription) {
      this.voucherSubscription.unsubscribe();
    }
    if (this.animationDestroy$) {
      this.animationDestroy$.next();
      this.animationDestroy$.complete();
    }
  }

}
